<template>

    <div class="block" v-if="linkPage">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="linkPage.currentPage"
            :page-sizes="pageSizes"
            :page-size="linkPage.perPage"
            :page-count="linkPage.pageCount"
            layout="total, sizes, prev, pager, next, jumper"
            :total="parseInt(linkPage.totalCount)">
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        linkPage: {
            // currentPage: 0,
            // perPage: 0,
            // pageCount: 0,
            // totalCount: 0
            type: Object
        },
        pageSizes: {
            type: Array,
            default: function () {
                return [10, 20, 30, 50, 100];
            }
        },
        /**
         * 启用事件传递分页参数
         * 主要用于解决，父子组件都依赖 beforeRouteUpdate 事件来监听分页的时候，
         * 子组件的 beforeRouteUpdate 会被父组件拦截，导致子组件的分页失效
         */
        enableEvent: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        'linkPage.perPage': function (val, original) {
            this.eventParams.perPage = val;
        }
    },
    created: function() {
        //this.linkPage = this.linkPage;
    },

    data() {
        return {
            // 每页显示条数控制
            eventParams: {
                page: 1,
                perPage: 20
            }
        };
    },

    methods: {
        handleSizeChange(val) {

            if (this.enableEvent == true) {
                this.eventParams.perPage = val;
                this.$emit("change", this.eventParams);
                return;
            }

            let data = { path: "", query: {} };
            data.path = this.$route.path;
            // 合并路由中已有参数
            data.query = JSON.parse(JSON.stringify(this.$route.query));
            data.query["perPage"] = val;

            this.$router.push(data);
            this.linkPage.perPage = val;
        },

        handleCurrentChange(val) {

            if (this.enableEvent == true) {
                this.eventParams.page = val;
                this.$emit("change", this.eventParams);
                return;
            }

            let data = { path: "", query: {} };
            data.path = this.$route.path;
            // 取得路由中已有参数
            data.query = JSON.parse(JSON.stringify(this.$route.query));
            data.query["page"] = val;
            // if (this.$route.query["perPage"]) {
            //     data.query["perPage"] = this.$route.query["perPage"];
            // } else {
            //     data.query["perPage"] = this.linkPage.perPage;
            // }

            data.query["perPage"] = this.linkPage.perPage;

            this.$router.push(data);
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/widgets/Pagination.vue